import { render, staticRenderFns } from "./ProviderAddress.vue?vue&type=template&id=6cbf956a&scoped=true&"
import script from "./ProviderAddress.vue?vue&type=script&lang=js&"
export * from "./ProviderAddress.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAddress.vue?vue&type=style&index=0&id=6cbf956a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf956a",
  null
  
)

export default component.exports